import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';

import { ArrowBack } from '@mui/icons-material';

import { Tooltip } from '../../../_shared/tooltip/Tooltip';
import title from '../../../_assets/dbd-title.png';
import thumbnail from '../../../_assets/thumbnail/dbd.webp';
import { FaqDbd } from './faq-dbd/FaqDbd';
import { useConfig } from '../../../ConfigContext';
import { GameConfig } from '../../../Config.model';
import { Breadcrumb, BreadcrumbPath } from '../../../_shared/breadcrumb/Breadcrumb';
import { ProviderMerge } from '../../providers/provider/ProviderMerge';
import { Promotions } from '../../promotion/Promotions';

export function DbdGame(): JSX.Element {
  const { t } = useTranslation(['dbd', 'translation']);
  const history = useHistory();
  const config = useConfig();
  const [dbdConfig, setDbdConfig] = useState<GameConfig>(null);
  const [gameDisabledFeature, setGameDisabledFeature] = useState<string[]>([]);
  const breadcrumb: BreadcrumbPath[] = [
    {
      key: 'button.my-account',
      path: '/account/my-account',
    },
    {
      key: 'Dead by Daylight',
      path: '',
    },
  ];
  const back = (): void => {
    history.push('/');
  };

  useEffect(() => {
    const co = config.serverConfig.gamesConfig?.find(((gamecConfig) => gamecConfig.id === 'dbd'));

    if (!co) {
      history.push('/');
    } else {
      setDbdConfig(co);
      const { killswitch } = co;
      if (Object.keys(killswitch).length) {
        Object.keys(killswitch).forEach((key) => {
          if (killswitch[key] === true) {
            setGameDisabledFeature([...gameDisabledFeature, key]);
          }
        });
      }
    }
  }, []);

  return (
    <div className='game-container our-game-container'>
      <img className='game-thumbnail' src={thumbnail} alt='DBD Thumbnail' />
      <div className='banner'>
        <button type='button' className='btn btn-secondary back-btn' onClick={back}>
          <ArrowBack className='icon' />
          {t('translation:button.back')}
        </button>
        <Breadcrumb paths={breadcrumb} />
        <img className='title' src={title} alt='title dbd' height={120} />

        <div className='subtitle'>
          <h3 className='cross-progression-title'>
            {t('translation:account.my-account.crossProgression')}
          </h3>
          <Tooltip id='tooltip.merge' message='tooltip.merge' />
        </div>

        <div className='providers-container'>
          {dbdConfig?.providers.map((provider) => (
            <ProviderMerge
              key={provider}
              gameId={dbdConfig.id}
              providerName={provider}
              isDisabled={gameDisabledFeature.indexOf('merge') !== -1}
            />
          ))}
        </div>
        <Promotions />
      </div>

      <section className='faq' id='faq'>
        <FaqDbd />
      </section>
    </div>
  );
}
